import React from 'react';
import { CommonIconProps } from './Icon';

const Step2Icon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <rect width="24" height="24" rx="12" fill={color} />
    <path
      d="M9.68408 16V14.7812L12.5317 12.1445C12.7739 11.9102 12.9771 11.6992 13.1411 11.5117C13.3078 11.3242 13.4341 11.1406 13.52 10.9609C13.606 10.7786 13.6489 10.582 13.6489 10.3711C13.6489 10.1367 13.5955 9.9349 13.4888 9.76562C13.382 9.59375 13.2362 9.46224 13.0513 9.37109C12.8664 9.27734 12.6567 9.23047 12.4224 9.23047C12.1776 9.23047 11.964 9.27995 11.7817 9.37891C11.5994 9.47786 11.4588 9.61979 11.3599 9.80469C11.2609 9.98958 11.2114 10.2096 11.2114 10.4648H9.60596C9.60596 9.94141 9.72445 9.48698 9.96143 9.10156C10.1984 8.71615 10.5304 8.41797 10.9575 8.20703C11.3846 7.99609 11.8768 7.89062 12.4341 7.89062C13.007 7.89062 13.5057 7.99219 13.9302 8.19531C14.3573 8.39583 14.6893 8.67448 14.9263 9.03125C15.1632 9.38802 15.2817 9.79687 15.2817 10.2578C15.2817 10.5599 15.2218 10.8581 15.1021 11.1523C14.9849 11.4466 14.7752 11.7734 14.4731 12.1328C14.1711 12.4896 13.7453 12.918 13.1958 13.418L12.0278 14.5625V14.6172H15.3872V16H9.68408Z"
      fill="white"
    />
  </>
);

export default Step2Icon;
